import { textConstants } from 'constants/texts';
import { useAmplitude } from 'hooks/useAmplitude';
import { useDeviceSize } from 'hooks/useDeviceSize';
import { useSendTracking } from 'hooks/useSendTracking';
import { useTruckerProps } from 'hooks/useTruckerProps';

const useGeneralInfoEvents = () => {
  const { isMobile, isTablet } = useDeviceSize();

  const { sendAmplitude } = useAmplitude();
  const { sendTrackingJaiminho } = useSendTracking();
  const { freight, eventsSource, freightId, truckerId } = useTruckerProps();

  const bankInfoCopiedEvent = () => {
    const device = isMobile || isTablet ? 'mobile' : 'desktop';

    sendAmplitude('trucker_profile_bankinfo_copied', {
      device,
      freightCode: freight?.code || textConstants.notAvailaible,
      truckerId,
      source: eventsSource,
    });
    sendTrackingJaiminho(
      {
        nameEvent: 'trucker_profile_bankinfo_copied',
        data: {
          device,
          freightId: freightId ? `hashed|${freightId}` : textConstants.notAvailaible,
          truckerId: `hashed|${truckerId}`,
          source: eventsSource,
        },
      },
      'trucker_profile'
    );
  };

  return { bankInfoCopiedEvent };
};

export default useGeneralInfoEvents;
